

import axios from 'axios';
import API_BASE_URL from './config';




const auth = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',

  },
});



const abtUs = async () => {
  try {
    const response = await auth.get('/about-us');

   
    return response.data;

  } catch (error) {
    if (error.response && (error.response.status === 400 || error.response.status === 401)) {
      console.log(error.response);
    }
    throw error;
  }
};


export default abtUs;
